var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRetail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Tags-Double--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Tags Double Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7 1.5a5.22 5.22 0 0 1 3.47 1.44l11 11a3.58 3.58 0 0 1 0.86 1.44 0.24 0.24 0 0 0 0.18 0.17 0.27 0.27 0 0 0 0.24 -0.06l0.66 -0.66a2 2 0 0 0 0 -2.83l-11 -11A3.73 3.73 0 0 0 10 0H5a2 2 0 0 0 -1.8 1.14 0.23 0.23 0 0 0 0 0.24 0.22 0.22 0 0 0 0.21 0.12Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 23.41a2 2 0 0 0 1.41 0.59 2 2 0 0 0 1.41 -0.59l3 -3 2.59 -2.58a2 2 0 0 0 0 -2.83l-11 -11A3.73 3.73 0 0 0 7 3H2a2 2 0 0 0 -2 2v5a3.73 3.73 0 0 0 1 2.41ZM5.5 7A1.5 1.5 0 1 1 4 8.5 1.5 1.5 0 0 1 5.5 7Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRetail);
export default ForwardRef;